module.exports = {
	"classes": [
		"whyauth0-page",
		"header-dark"
	],
	"title": "Why Auth0",
	"metas": {
		"description": "Identity in Modern Cloud-Hybrid Apps and APIs is Radically More Complex. Traditional Identity Infrastructure Is Obsolete"
	},
	"opengraph": {},
	"twittercard": {},
	"canonical": "/why-auth0"
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/why-auth0/metadata.json
// module id = 1143
// module chunks = 0